var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      class: _vm.$style.dropdown,
      attrs: { "offset-y": "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c("button", _vm._g({ class: _vm.$style.headerLogin }, on), [
                _c("svg", {
                  directives: [{ name: "svg", rawName: "v-svg" }],
                  class: _vm.$style.headerLoginIcon,
                  attrs: { symbol: "account-icon" }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { class: _vm.$style.headerText },
                  [
                    _vm.isAuthenticated && !_vm.isGuest && _vm.authUser
                      ? [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.authUser.firstName) +
                              " " +
                              _vm._s(_vm.authUser.lastName) +
                              "\n        "
                          )
                        ]
                      : [_vm._v("\n          Join/Sign In\n        ")]
                  ],
                  2
                ),
                _vm._v(" "),
                _c("svg", {
                  directives: [{ name: "svg", rawName: "v-svg" }],
                  class: _vm.$style.headerDownIcon,
                  attrs: { symbol: "chevron-down" }
                })
              ])
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "v-list",
        { class: _vm.$style.dropdownMenu },
        [
          _vm.isAuthenticated && !_vm.isGuest && _vm.authUser
            ? [
                _c(
                  "v-list-tile",
                  { class: _vm.$style.dropdownItem },
                  [
                    _c(
                      "v-list-tile-title",
                      { on: { click: _vm.openAccount } },
                      [
                        _c(
                          "a",
                          {
                            class: _vm.$style.dropdownLink,
                            attrs: { href: "#" }
                          },
                          [_vm._v("My Account")]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-list-tile",
                  [
                    _c("v-list-tile-title", { on: { click: _vm.logout } }, [
                      _c(
                        "a",
                        {
                          class: _vm.$style.dropdownLink,
                          attrs: { href: "#" }
                        },
                        [_vm._v("Log Out")]
                      )
                    ])
                  ],
                  1
                )
              ]
            : [
                _c(
                  "v-list-tile",
                  { on: { click: _vm.login } },
                  [
                    _c("v-list-tile-title", [
                      _c(
                        "a",
                        {
                          class: _vm.$style.dropdownLink,
                          attrs: { href: "#" }
                        },
                        [_vm._v("Login")]
                      )
                    ])
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/desktop/components/DesktopUserData.vue?vue&type=template&id=7e542bff&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&
// module id = null
// module chunks = 